import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SupportedLocale } from "@/i18n";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";
import { Artwork } from "@/lib/types";
import { AccordionClass } from ".";

interface TirageKnownDescriptionAccordionProps {
  data: Artwork;
  isPhotoMaster: boolean;
  locale: SupportedLocale;
  t: (key: string) => string;
}

export function TirageKnownDescriptionAccordion({
  data,
  isPhotoMaster,
  locale,
  t,
}: TirageKnownDescriptionAccordionProps) {
  const artworkData = data as any;
  if (
    !isPhotoMaster ||
    !artworkData.oeuvresTirageKnownDescriptionPublished ||
    !artworkData.oeuvresTirageKnownDescription ||
    !(artworkData.oeuvresTirageKnownDescription as Record<string, string>)?.[
      locale
    ]
  ) {
    return null;
  }

  return (
    <AccordionItem value="tirage-known-description">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleArtworkSubtitleTirageKnownDescription")}
      </AccordionTrigger>
      <AccordionContent>
        <div
          dangerouslySetInnerHTML={{
            __html:
              (
                artworkData.oeuvresTirageKnownDescription as Record<
                  string,
                  string
                >
              )[locale] || "",
          }}
          className={AccordionClass}
        />
      </AccordionContent>
    </AccordionItem>
  );
}
